export default __webpack_public_path__ + "static/media/c11.5227769c.png";